export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./LearnMore.vue?vue&type=template&id=79cd3331&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/LearnMore.vue?vue&type=template&id=79cd3331&scoped=true&
// module id = 244
// module chunks = 0